import React, { useState } from "react";
import "./Contact.css";
import Header from "../homepage/header";

const Contact = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handlePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <div>
      <Header />
      <div className="contact-container">
        <h1 className="contact-title">Contact Us</h1>

        <div className="contact-cards-container">
          <div className="contact-card">
            <h2 className="card-title">Internship Opportunity</h2>
            <p className="card-content">
              We are currently offering internship opportunities for students passionate about cyber security. Interns will work closely with our research team on cutting-edge cyber security projects.
            </p>
            <a href="https://forms.gle/NQW2htFpJq15nF2B7"
              className="contact-link"
              target="_blank"
              rel="noopener noreferrer">
              Apply Now
            </a>
          </div>

          <div className="contact-card">
            <h2 className="card-title">Consultancy Work</h2>
            <p className="card-content">
              Our lab offers consultancy services in the areas of cyber security, IoT security, and data privacy. We provide customized solutions to organizations, helping them secure their digital infrastructure.
            </p>
            <button className="contact-link" onClick={handlePopup}>Get in Touch</button>
          </div>
        </div>

        <div className="department-address-card">
          <div className="contact-card">
            <h2 className="card-title">Address</h2>
            <p className="card-content">
              Cyber Security Research Lab <br />
              Department of Computer Science and Engineering <br />
              National Institute of Technology Karnataka <br />
              Surathkal, Mangalore - 575025, India <br />
              Phone: +91-824-2473402 <br />
              Email: csrl@nitk.edu.in / mp_singh@nitk.edu.in
            </p>
          </div>
        </div>
      </div>

      {/* Popup for Consultancy Work */}
      {showPopup && (
        <div className="popup-overlay" onClick={handlePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <span className="popup-close" onClick={handlePopup}>&times;</span>
            <h2>Contact for Consultancy</h2>
            <p>Email: <a href="mailto:mp_singh@nitk.edu.in">mp_singh@nitk.edu.in</a></p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;
